module.exports = __webpack_public_path__ + "static/media/fontWeight.f8e53a28.jpg";